{
  "common" : {
    "show" : "Afficher",
    "about" : "À propos",
    "newPost" : "Nouveau poste",
    "active" : "Actif",
    "change" : "Changement",
    "remove" : "Supprimer",
    "cancel" : "Annuler",
    "publish" : "Publier",
    "save" : "Sauvegarder",
    "draft" : "Ébauche",
    "scheduled" : "Prévu",
    "published" : "Publié",
    "actions" : "Actions",
    "archive" : "Archives",
    "delete" : "Supprimer",
    "edit" : "Modifier",
    "edited" : "Modifié",
    "settings" : "Réglages",
    "updatedOn" : "Mise à jour le",
    "blogPost" : "Article de blogue",
    "category" : "Catégorie",
    "author" : "Auteur",
    "status" : "Statut",
    "errors" : "Erreurs",
    "all" : "Tous",
    "archived" : " Archivé",
    "back" : "Retour",
    "restore" : "Restaurer cette version",
    "next" : "Suivant",
    "previous" : "Précédent",
    "continue" : "Continuer",
    "paid" : "Payé",
    "free" : "Gratuit",
    "uploadImagesVideos" : "Téléverser des images / vidéos",
    "upload" : "Téléverser",
    "add" : "Ajouter",
    "to" : "à",
    "on" : "Allumé",
    "from" : "de",
    "members" : "Membres",
    "visibility" : "Visibilité",
    "private" : "Privé",
    "public" : "Public",
    "description" : "Description",
    "managedBy" : "Géré par",
    "noManagers" : "Aucun gestionnaire",
    "noDescription" : "Aucune description",
    "more" : "Plus",
    "moreCaps" : "More",
    "less" : "moins",
    "and" : "et",
    "in" : "in",
    "allSet" : "Vous êtes prêt !",
    "createdBy" : "Créé par",
    "home" : "Accueil",
    "selected" : "Sélectionné",
    "groupMembers" : "Membres du groupe",
    "everyone" : "Tout le monde",
    "manager" : "Gestionnaire",
    "leave" : "Quitter",
    "membersList" : "Liste des membres",
    "findChannelManagers" : "Rechercher les gestionnaires de canaux",
    "searchGroupMembers" : "Recherche de membres du groupe",
    "searchMembers" : "Recherche de membres",
    "searchMember" : "Rechercher un membre",
    "enterDescription" : "Saisissez la description",
    "apply" : "Applique",
    "selectRole" : "Sélectionner un rôle",
    "people" : "Les personnes",
    "viewProfile" : "Afficher le profil",
    "leaderboard" : "Leaderboard",
    "events" : "Événements",
    "logOut" : "Se déconnecter",
    "share" : "Partager",
    "copyLink" : "Copier le lien",
    "reply" : "Réponse",
    "download" : "Télécharger",
    "noPreviewAvailable" : "Aucun aperçu disponible",
    "userNotFound" : "Utilisateur non trouvé",
    "unableToPreviewPdf" : "Actuellement, impossible de prévisualiser le fichier PDF. Veuillez le télécharger pour le voir.",
    "failedToDownloadPdf" : "Impossible de télécharger le fichier PDF",
    "notifyAll" : "Notifier tout le monde sur le canal",
    "communities" : "Communautés",
    "courses" : "Cours",
    "affiliates" : "Affiliation",
    "chats" : "Clavardage",
    "switchToDarkMode" : "Passer en mode Foncé",
    "switchToLightMode" : "Passer en mode lumière",
    "editProfile" : "Modifier le profil",
    "account" : "Compte",
    "logout" : "Déconnexion",
    "noResults" : "Aucun résultat",
    "confirmPayment" : "Confirmer le paiement",
    "done" : "Terminé",
    "manage" : "GÉRER",
    "copied" : "Copié",
    "submit" : "Soumettre",
    "request" : "Demande",
    "approve" : "Approuver",
    "decline" : "Refuser",
    "comingSoon" : "Bientôt disponible",
    "detailsUpdatedSuccessfully" : "Info mise à jour avec succès",
    "oopsUnableToSaveDetails" : "Oups! Impossible d'enregistrer les détails.",
    "verificationFailedPleaseTryAgain" : "La vérification a échoué! Veuillez réessayer",
    "loading" : "Chargement",
    "title" : "Titre",
    "addLink" : "Ajouter un lien",
    "writeHere" : "Écrire ici",
    "copy" : "Copier",
    "register" : "S'inscrire",
    "registered" : "Inscrit",
    "search" : "Rechercher",
    "confirm" : "Confirme",
    "success" : "Succès",
    "toReview" : "Pour Avis",
    "invite" : "Invite",
    "contributions" : "Conversations",
    "communitiesSettings" : "Réglages de la communauté",
    "create" : "Créer",
    "name" : "Nom",
    "linkCopied" : "Lien Copié!",
    "move" : "Déplacer",
    "irreversible" : "irréversible",
    "close" : "Fermer",
    "greeting" : "Hier, {name} vous",
    "managePayments" : "Gérer les paiements",
    "manageYourAccount" : "Gérer votre Compte",
    "accountSettings" : "Réglages du Compte",
    "proceed" : "Poursuivre",
    "uploading" : "Téléversement",
    "retry" : "Réessayer",
    "login" : "Login"
  },
  "imageUpload" : {
    "cropYourAvatar" : "Cropez votre avatar",
    "dragToReposition" : "Traîner pour repositionner"
  },
  "mediaUpload" : {
    "uploadVideo" : "Téléverser la vidéo",
    "addVideoUsingLink" : "Ajouter une vidéo à l’aide d’un lien"
  },
  "mandatedInfoModal" : {
    "completeYourProfile" : "Finissez votre Profil",
    "profileIntentMessage1" : "Les communautés semblent étranges sans visages ni noms.",
    "profileIntentMessage2" : "Les profils instaurent la confiance et créent des liens avec les autres",
    "complete" : "COMPLET",
    "recommendedAspectRatio" : "Téléverser un {types} Recommander l'apparence 1:1",
    "addBio" : "Ajouter une biographie... (En option)"
  },
  "validations" : {
    "nameRequired" : "Le nom est obligatoire",
    "invalidDescription" : "Description invalide!"
  },
  "payment" : {
    "recurringWithTrial" : "Vous serez facturé {currencySymbol}{price} par {interval} après la période d'essai terminée avec la possibilité d'annuler à tout moment.",
    "recurring" : "{currencySymbol}{price} par {interval} avec la possibilité d'annuler à tout moment.",
    "oneTime" : "{currencySymbol}{price} {paymentText}",
    "defaultOneTimeText" : "Prix unique pour l'abonnement.",
    "totalAmount" : "Montant total",
    "trialDays" : "{days} Essai d'une journée",
    "securePayments" : "Paiements 100% sécurisés et sûrs",
    "allowToChargeCard" : "En fournissant les informations de votre carte, vous autorisez {locationName} à charger la carte pour les paiements futurs conformément à leurs conditions.",
    "paymentSuccessful" : "Paiement réussi!"
  },
  "channel" : {
    "notifications" : {
      "managersEdited" : "Gestionnaires édités avec succès!",
      "managersAdded" : "Gestionnaires ajoutés avec succès!",
      "managersAddedToChannel" : "gestionnaires ajoutés à",
      "memberPostingEnabled" : {
        "title" : "Mise à jour avec succès",
        "content" : "La publication des membres a été active"
      },
      "memberPostingDisabled" : {
        "title" : "Mise à jour avec succès",
        "content" : "Les membres de la publication ont été Handicapés"
      },
      "created" : {
        "title" : "Nouvelle chaîne créée",
        "content" : ""
      },
      "updated" : {
        "title" : "Paramètres de canal mis à jour",
        "content" : ""
      },
      "deleted" : {
        "title" : "La chaîne a été supprimée avec succès",
        "content" : ""
      },
      "error" : {
        "createFailed" : {
          "title" : "Impossible de créer un canal",
          "content" : "Veuillez réessayer plus tard"
        },
        "updateFailed" : {
          "title" : "Échec de la mise à jour de la chaîne",
          "content" : "Veuillez réessayer plus tard"
        },
        "managersEditedFailed" : {
          "title" : "La mise à jour des gestionnaires a échoué!",
          "content" : ""
        },
        "addFailed" : {
          "title" : "L'ajout de gestionnaires n'est pas un succès!",
          "content" : ""
        }
      }
    },
    "createChannel" : "Créer un canal",
    "updateChannel" : "Canal de mise à jour",
    "addMembers" : "Ajouter des membres",
    "addManagers" : "Ajouter des gestionnaires",
    "typeToAddMoreMembers" : "Type pour inclure plus de membres",
    "examplePlaceholder" : "ex. John ou Jane",
    "makeChannelManager" : "Créer un gestionnaire de canaux",
    "removeFromChannelManager" : "Extraire du Gestionnaire de canaux",
    "manager" : "Gestionnaire",
    "channelManager" : "Gestionnaire de canaux",
    "noMembersFound" : "Aucun membre trouvé.",
    "noManagersFound" : "Aucun gestionnaire trouvé.",
    "removeChannelMember" : "Extraire le membre de canal",
    "removeConfirmationMessage" : "Êtes-vous sûr de vouloir supprimer",
    "makeManagerConfirmationMessage" : "Voulez-vous vraiment faire",
    "makeManagerConfirmationMessage2" : "un gestionnaire de chaîne in",
    "channelName" : "Nom du canal",
    "channelIcon" : "Icône de chaîne",
    "addChannel" : "Ajouter une chaîne",
    "editChannel" : "Modifier le Canal",
    "announcementChannel" : "Canal AVIS",
    "noChannelsAvailable" : "Aucun canal disponible",
    "makeChannelPrivate" : "Rendre le canal Privé",
    "makeChannelPrivateMessage" : "Restreindre l'accès des membres à toutes les discussions et les interactions du canal.",
    "readOnlyChannel" : "Canal de Lire seule",
    "readOnlyChannelMessage" : "Les membres peuvent afficher des informations et des informations IMPORTANT , mais seules les administrateurs/ propriétaires du canal peuvent partager ici.",
    "createPrivateChannel" : "Créer ce Canal privé",
    "createPrivateChannelMessage" : "Seuls les Membres invités. Aucun membre ne verra cet Espace",
    "allowMembersToPost" : "Membres actifs à partager",
    "allowMembersToPostMessage" : "Activer cette option pour créer des publications et des commentaires",
    "enableMemberPostingConfirmation" : {
      "mainMessage" : "L'activation des membres de l'activation des membres de l'activation de la publication d'annonces de membres actifs pour créer et partager des publications au sein du canal.",
      "mainMessage2" : "Assurez-vous que tous les membres sont marqués des nouvelles autorisations de publication.",
      "pointer1" : "Cette Action peut être annulée à n'importe quelle Date.",
      "pointer2" : "Toutes les publications créées par les membres seront visibles par Tout le monde in le canal."
    },
    "restrictMembersFromPosting" : "Empêcher les membres de soumettre",
    "restrictMembersFromPostingMessage" : "La désactivation de cette option empêchera les membres de la modification de la publication et de l'avis au sein du canal.",
    "disableMemberPostingConfirmation" : {
      "mainMessage" : "Désactiver les membres de la publication empêchera tout membre de l'équipe et le partage des publications au sein du canal.",
      "mainMessage2" : "Assurez-vous que tous les membres sont marqués par les nouveaux restrictions de publication.",
      "pointer1" : "Cette Action peut être annulée à n'importe quelle Date.",
      "pointer2" : "Tous les publications créés par les membres avant ce changement resteront visibles pour tout le monde in le canal."
    },
    "deleteChannel" : "Supprimer le canal",
    "deleteChannelMessage" : "La suppression du canal entraîne la perte définitive de toutes les données qui y sont associées.",
    "deleteChannelMessageWithCourse" : "La Supprimer du canal empêchera définitivement la suppression de toutes les données et tous les Cours liés à ce canal Public à moins que vous les supprimerez en premier.",
    "editChannelName" : "Modifier le nom du canal",
    "editChannelDescription" : "Modifier la description du canal",
    "channelNamePlaceholder" : "par exemple Rapports marketing",
    "editManagers" : "Modifier les gestionnaires",
    "channelManagers" : "Gestionnaires de canaux",
    "leaveChannel" : "Abandonner la chaîne",
    "leaveChannelConfirmation" : "Voulez-vous vraiment quitter ce canal?",
    "changeToPrivateChannel" : "Rendre le canal Privé",
    "changeToPrivateChannelMessage" : "Rendre le canal privé limitera l'utilisation du canal pour les interactions et les discussions à ses membres uniquement.",
    "changeToPrivateChannelConfirmation" : {
      "mainMessage" : "Le changement de ce canal pour le privé empêchera le nombre maximal d'emplacements pour la sélection des membres et des administrateurs.",
      "mainMessage2" : "N'oubliez pas d'inclure les membres de votre choix dans votre canal privé.",
      "pointer1" : "Cette Action est",
      "pointer2" : "Les nouveaux membres ajoutés au canal auront accès pour toutes les discussions et les contacts au sein du canal."
    },
    "peopleWhoCanManage" : "Des gens qui peuvent gérer",
    "addChannelHelperText" : "Afficher plus la communauté : Ajouter des canaux pour des discussions, Duet et une connexion."
  },
  "chat" : {
    "unblockUser" : "Débloquer l'utilisateur",
    "blockUser" : "Bloquer l'utilisateur",
    "blockMessage1" : "Vous ne pourrez plus envoyer de messages à cet utilisateur.",
    "blockMessage2" : "Ce compte ne sera pas bloqué sur le groupe. Vous pourrez peut-être toujours voir leurs publications, commentaires et réactions.",
    "deleteChat" : "Supprimer le chat",
    "deleteChatMessage" : "Voulez-vous vraiment supprimer cette conversation?",
    "block" : "Bloquer",
    "conversation" : "conversation",
    "messageNotSent" : "Ce message n'a pas été envoyé",
    "sending" : "Envoi...",
    "youAndUserKnowEachOther" : "Vous et {name} vous vous connaissez",
    "startConversationWithHi" : "Commencez une conversation en envoyant « Salut »",
    "accountSettings" : "Paramètres du Compte",
    "blockedUserMessage" : "Vous avez bloqué { name }, Vous ne pouvez ni envoyer ni recevoir de messages. Débloquez-les pour démarrer une conversation. Pour consulter votre liste d'utilisateurs bloqués, visitez votre",
    "blockRecipientMessage" : "{ name } vous a bloqué. Vous ne pouvez pas envoyer ou recevoir de messages.",
    "nothingFound" : "Rien n'a été trouvé!",
    "pleaseCheckUsername" : "Veuillez vérifier le nom d'utilisateur et réessayer",
    "startChatting" : "Commencer à chatter",
    "noChatYet" : "Apparence que vous n'avez encore discuté avec personne.",
    "noChatYetMessage" : "Recherchez un contact et faites le premier pas!",
    "noConversationsFound" : "Aucune conversation trouvée",
    "searchMembersAndStartChatting" : "Recherche des Membres et commencez à discuter",
    "cannotMessageDeletedUser" : "Vous ne pouvez pas téléverser des messages à un utilisateur pris en charge",
    "message" : "Message",
    "media" : "Médias",
    "files" : "Fichiers"
  },
  "comments" : {
    "reportComment" : "Signaler un commentaire",
    "reportCommentMessage" : "Êtes-vous sûr de vouloir signaler ce commentaire ?",
    "deleteComment" : "Supprimer un commentaire",
    "editComment" : "Modifier le commentaire",
    "loadMoreReplies" : "Charger plus de réponses",
    "deleteCommentMessage" : "Voulez-vous vraiment supprimer ce commentaire ?",
    "writeComment" : "Écrire un commentaire",
    "comment" : "COMMENTER",
    "cancel" : "ANNULER",
    "save" : "ENREGISTRER",
    "replyingTo" : "En réponse à",
    "newComment" : "Nouveau commentaire",
    "latest" : "Dernier",
    "onlyAdminsCanComment" : "Seuls les administrateurs de la communauté peuvent commenter in ce canal."
  },
  "embeds" : {
    "uploadImage" : "Téléverser une photo",
    "addYoutubeVimeoLoomLink" : "Ajoutez un lien Youtube, Vimeo ou Loom",
    "uploadAttachment" : "Téléverser des fichiers PDF, CSV ou XLSX",
    "addAttachment" : "Ajouter une pièce jointe",
    "allowedTypes" : "SVG, PNG, JPG ou GIF (max. (800x400px)",
    "placeholder" : "Ajoutez un lien Youtube, Vimeo ou Loom",
    "uploadVideo" : "Téléverser/Lier une Vidéo",
    "uploadVideoPlaceholder" : "Ajoutez un lien Youtube, Vimeo ou Loom",
    "uploadVideoAllowedTypes" : "Téléverser un fichier vidéo MP4",
    "addEmoji" : "Ajouter des émojis",
    "emojiSuggestion" : "Ouvre le sélecteur d'Emoji",
    "addGif" : "Ajouter un GIF",
    "gifSuggestion" : "Ouvre le sélecteur de GIF",
    "addImage" : "Ajouter une image",
    "imageSuggestion" : "Ouvre votre galerie",
    "addVideo" : "Ajouter une vidéo",
    "videoSuggestion" : "Ouvre votre galerie",
    "selectFile" : "Sélectionner le fichier",
    "attachmentSuggestion" : "Ouvre le gestionnaire de fichiers",
    "takePhoto" : "Prendre une photo",
    "uploadPhotoVideo" : "Téléverser une photo/vidéo",
    "limitExceeded" : "Limite dépassée",
    "limitExceededMessage" : "Vous ne pouvez pas joindre plus de 4 fichiers",
    "errorWhileUploadingFile" : "Erreur lors du téléchargement du fichier! Veuillez réessayer",
    "clickToUpload" : "Clique pour télécharger",
    "orDragAndDrop" : "ou glisser-déposer",
    "validUrl" : "Une URL valide est nécessaire",
    "enterSomeText" : "Saisissez du texte",
    "addLink" : "Ajouter un lien",
    "text" : "Texte",
    "addVideoLink" : "YouTubeVimeo Wistia",
    "uploadVideoAndImages" : "Téléverser des vidéo et des images",
    "recommendedAspectRatio" : "Pourcentage {ratio}apparence"
  },
  "tabSwitcher" : {
    "discussion" : "Discussion",
    "learning" : "Apprentissage",
    "members" : "Membres",
    "leaderboard" : "Leaderboard",
    "channels" : "Canal",
    "groups" : "Groupes",
    "more" : "Plus",
    "home" : "Accueil",
    "discover" : "Discover",
    "courses" : "Courses",
    "communities" : "Communities"
  },
  "groupInfo" : {
    "pinGroup" : "Groupe de pipeline",
    "unpinGroup" : "Groupe non .",
    "maxPinnedGroupsLimit" : "Seuls 4 groupes au maximum peuvent être définis",
    "publicGroup" : "Groupe public",
    "privateGroup" : "Groupe Privé",
    "members" : "Membres",
    "posts" : "Articles",
    "admin" : "Administrateur",
    "settings" : "PARAMÈTRES",
    "inviteMembers" : "INVITER LES MEMBRES",
    "answerQuestions" : "Répondre aux questions",
    "toJoin" : "pour rejoindre {name}",
    "changeRole" : "Changement de rôle",
    "removeFromGroup" : "Extraire de la Collection",
    "contributor" : "Contributeur",
    "membershipAnswers" : "Réponses d'adhésion",
    "unbanMember" : "Débannir un membre",
    "banFromGroup" : "Ban du groupe",
    "requestedOn" : "Demandé le",
    "invitedOn" : "Invité le",
    "joinedOn" : "Rejoint",
    "noMembersFound" : "Aucun membre trouvé.",
    "youAreAllCaughtUp" : "Vous êtes pris en charge",
    "banUserConfirmation" : "Êtes-vous sûr de vouloir bannir cet utilisateur du groupe?",
    "deleteContentCheckbox" : "Supprimer tout ce",
    "active" : "Actif",
    "admins" : "Admins",
    "contributors" : "Contributeurs",
    "requested" : "Demandé",
    "banned" : "Interdits",
    "invited" : "Invité",
    "answeredQuestions" : "Questions répondues",
    "answeredQuestionsMessage" : "répondu à la question suivante pour rejoindre",
    "darkMode" : "Mode sombre",
    "darkModeMessage" : "Modifier l'apparence de la communauté pour réduire l'éblouissement et reposer vos yeux.",
    "accessGranted" : "Accès accordé : commencez votre aventure d'apprentissage.",
    "paymentReceived" : "Le paiement a été reçu et votre demande de rejoindre le groupe est en cours d'examen.",
    "stepIntoAction" : "Passez à l'action! Collaborons et amusons-nous.",
    "viewMembersAndMemberDetails" : "Voir les membres et les détails des membres",
    "reviewContentReportsAndMore" : "Consultez les rapports de contenu et plus encore",
    "toReview" : "À examiner",
    "switchToOtherGroups" : "Passer à d'autres groupes",
    "placeholders" : {
      "yourAnswer" : "Votre réponse"
    },
    "notifications" : {
      "userBanned" : "L’utilisateur a été banni de la Collection avec succès",
      "somethingWentWrong" : "Une erreur s'est produite! Veuillez réessayer plus tard"
    },
    "membershipSettings" : "Paramètres d'abonnement",
    "paymentFailed" : "Le paiement a échoué!",
    "paymentFailedMessage" : "Paiement échoué, votre demande de rejoindre le groupe a été refusée.",
    "gamification" : {
      "addRewards" : "Ajouter des récompenses",
      "title" : "Titre",
      "description" : "Ajoute une description",
      "textbox" : "Zone de texte",
      "singleSelect" : "Sélection individuelle",
      "multipleSelect" : "Sélection multiple",
      "question" : "Question",
      "validations" : {
        "titleRequired" : "Veuillez indiquer le titre",
        "descriptionRequired" : "S'il vous plaît donner une description",
        "somethingWentWrong" : "Une erreur s'est produite! Veuillez réessayer plus tard",
        "updatedRewards" : "Récompenses mises à jour"
      }
    },
    "customCode" : {
      "advanced" : "Avancé",
      "testPreview" : "Aperçu du test",
      "enableConfirmationMessage" : "Activez-le uniquement une fois que vous avez vérifié l'aperçu du test",
      "testPreviewMessage" : "Cela ouvrira un nouvel onglet avec l'aperçu du test de votre communauté. Vous pouvez l'utiliser pour vérifier si votre Code personnalisé fonctionne comme prévu.",
      "liveMode" : "Mode En direct",
      "customJS" : "JS Personnalisé",
      "customCSS" : "CSS Personnalisé",
      "trackingCode" : "Code de suivi",
      "headerCode" : "Code En-tête",
      "footerCode" : "Code de Pied de page"
    },
    "branding" : {
      "brandYourGroup" : "Vous pouvez  marquer votre Collection selon votre choix ici",
      "updateBranding" : "Mise à jour de l’image de marque",
      "clickToUploadFavicon" : "Cliquez pour télécharger le Favicon",
      "dragAndDropFavicon" : "Drag and drop a {types} (Aspect Ratio 1:1)",
      "clickToUploadCover" : "Cliquez pour télécharger la couverture",
      "dragAndDropCover" : "Drag and drop a {types} (Aspect Ratio 16:9)",
      "clickToUploadLogo" : "Cliquez pour télécharger le Logo de la Collection",
      "dragAndDropLogo" : "Drag and drop a {types} (Aspect Ratio 1:1)",
      "aspectRatioMustBe1To1" : "Le rapport d’aspect de la photo doit être de 1:1",
      "aspectRatioMustBe16To9" : "Le rapport d’aspect de la photo doit être de 16:9",
      "favicon" : "Favicon",
      "coverImage" : "Image de couverture",
      "logo" : "Logo",
      "invalidFileFormat" : "Oops! Invalid File Format/Type.",
      "pleaseUploadImageType" : "Supported file types: {types}"
    },
    "groupAppearance" : {
      "description" : "Vous pouvez configurer votre apparence de groupe selon vos choix ici",
      "slug" : "Mise à jour votre apparence de groupe ici",
      "colorMode" : "Mode Couleur",
      "previewTheLook" : "Voir un aperçu de la manière dont votre groupe apparaîtra in mode Léger et Foncé",
      "light" : "Léger",
      "dark" : "Foncé",
      "communityTheme" : "Thème de la communauté",
      "customTheme" : "Thème Personnalisé",
      "windowGradient" : "Gradient de la Fenêtre",
      "applyGradientColorsToYourSidebarAndTopbar" : "Applique des couleurs de Gradient à votre barre latérale et à votre barre supérieure",
      "labels" : {
        "sidebarBackground" : "Contexte de la barre latérale",
        "primary" : "PRIMAIRE",
        "secondary" : "Seconde",
        "tertiary" : "Terrible",
        "surface" : "SUPERPOSITION",
        "fontPrimary" : "Police primaire",
        "fontSecondary" : "Police supplémentaire",
        "fill" : "Remplir de la Couleur",
        "border" : "Bordure",
        "error" : "Erreur",
        "background" : "Contexte"
      },
      "customThemes" : {
        "default" : "Par défaut",
        "zestyCitrus" : "D'accord",
        "royalVelvet" : "Ellipses",
        "sunnyDelight" : "Coucher de soleil",
        "lushMeadow" : "Mis à jour",
        "azureDreams" : "Remplissage de l'arrière-plan",
        "bubblegumBliss" : "Fois",
        "ivoryWhisper" : "chuchoté d'origine",
        "midnightDeep" : "Propriétaire"
      },
      "unsavedChanges" : "Flux de travail non enregistré",
      "unsavedChangesMessage" : "Vous ont"
    },
    "promotionalLinks" : {
      "promotionalLinks" : "Liens promotionnels",
      "createPromotionalLinkDescription" : "Créer des Liens promotionnels pour votre Collection",
      "addPromotionalLink" : "Ajouter un lien",
      "deleteLink" : "Supprimer le lien",
      "deleteLinkConfirmation" : "Êtes-vous sûr de vouloir supprimer ce lien ?",
      "labels" : {
        "description" : "Description",
        "url" : "URL",
        "private" : "Privé",
        "privateLinksDescription" : "Les liens privés ne sont visibles que pour les membres de la Collection"
      },
      "placeholders" : {
        "enterLinkDescription" : "Saisissez la description du lien",
        "enterLinkURL" : "Entrez l'URL du lien"
      },
      "addPromotionalLinkDescription" : "Créer des liens pour votre groupe"
    },
    "membershipQuestions" : {
      "addQuestion" : "Ajouter une question",
      "editQuestion" : "Modifier la question",
      "editLevelName" : "Modifier le nom du niveau",
      "addOption" : "Ajouter une option",
      "level" : "Niveau",
      "name" : "Nom",
      "addMembersQuestionsDescription" : "Ajouter des questions aux membres à poser lorsqu'ils demandent l'accès à votre groupe",
      "enableMembershipQuestions" : "Activer les questions d'abonnement",
      "membershipQuestions" : "Questions sur l’abonnement",
      "deleteQuestion" : "Supprimer la question",
      "deleteQuestionConfirmation" : "Voulez-vous vraiment supprimer cette question?",
      "labels" : {
        "textBox" : "Zone de texte",
        "singleSelect" : "Sélection individuelle",
        "multipleSelect" : "Sélection multiple",
        "enableMembershipQuestions" : "Ajouter au moins une Question aux questions d'adhésion actives"
      },
      "validations" : {
        "questionRequired" : "Veuillez saisir une question",
        "answerOptionsRequired" : "Un minimum de deux Options est Obligatoire, et elles doivent être uniques",
        "somethingWentWrong" : "Une erreur s'est produite! Veuillez réessayer plus tard",
        "updatedQuestions" : "Questions mises à jour sur l'abonnement à la Collection",
        "levelNameRequired" : "Veuillez saisir le nom du niveau",
        "updatedLevelName" : "Nom du niveau mis à jour"
      },
      "placeholders" : {
        "enterLevelName" : "Nom du niveau",
        "selectOne" : "Sélectionnez une option",
        "keepItShort" : "gardez les choses courtes..",
        "exampleOffer" : "par exemple 10 %."
      },
      "privacyNotice" : "Je comprends que mon"
    },
    "gamificationAndRewards" : {
      "title" : "Personnaliser les Couches et les récompenses",
      "description" : "Personnalisez les noms de niveau et ajoutez des récompenses pour un meilleur engagement des membres",
      "gamification" : "Gamification",
      "rewards" : "Récompenses",
      "addRewards" : "Ajouter une récompense"
    },
    "invitations" : {
      "invitationSentSuccessfully" : "Invitation envoyée avec succès",
      "invitationSentSuccessfullyDescription" : "Invitation envoyée à {email}",
      "shareGroupLink" : "Partager le lien de votre groupe",
      "inviteMember" : "Inviter un membre",
      "inviteMemberDescription" : "Renforcez votre communauté en invitant un nouveau membre",
      "inviteViaEmail" : "Invitation via Email",
      "invitedMembersWillBeAutoApproved" : "Les membres invités seront automatiquement acceptés pour rejoindre le groupe.",
      "sendInvite" : "ENVOYER UNE INVITATION",
      "permissionDenied" : "Vous n'avez pas l'autorisation d'invitations de membres. Veuillez Contact votre administrateur.",
      "labels" : {
        "giveAdministrativePrivileges" : "Accorder des privilèges administratifs",
        "giveAdministrativePrivilegesDescription" : "Activer ce membre à effectuer toutes les actions administratives",
        "name" : "Nom",
        "email" : "Courriel"
      },
      "placeholders" : {
        "enterName" : "Saisis le nom",
        "enterEmail" : "Entrez le courriel"
      }
    },
    "groupDetails" : {
      "updateGroupDetails" : "Mettre à jour les Info de la Collection",
      "updateGroupDetailsDescription" : "Mettez à jour les détails de votre Collection ici",
      "slugNotAvailable" : "Limace de collection non disponible",
      "description" : "Expliquer la nature des discussions qui auront lieu au sein du groupe",
      "publicDescription" : "Tout le monde peut voir les publications de la Collection et les autres membres de la Collection",
      "privateDescription" : "Seuls les membres peuvent voir les publications de la Collection et les autres membres de la Collection",
      "accessibleFromSwitcher" : "Accessible depuis le commutateur",
      "accessibleFromSwitcherDescription" : "Votre Collection sera visible pour les non-Membres de la Collection dans le Commutateur",
      "allowMembersToInvite" : "Membres actifs pour invitations de nouveaux membres",
      "allowMembersToInviteDescription" : "Cacher l'invitation du bouton pour les membres lorsqu'ils sont transformés en Handicapés. Les membres peuvent invitations uniquement. Si ce n'est activé.",
      "slug" : "Limace de groupe",
      "discovery" : {
        "title" : "Découverte",
        "description" : "Faites-vous découvrir par millions d'Utilisateurs actifs. La Collection sera visible sur la page Découvrir dès que vous aurez plus de 10 Membres.",
        "discoverChannels" : "Découvrir des canaux",
        "joinGroupToExploreAllChannels" : "Le groupe pour visiter tout le canal"
      },
      "placeholders" : {
        "description" : "Saisissez une brève description"
      },
      "validations" : {
        "nameRequired" : "Veuillez saisir un nom de groupe valide!",
        "slugRequired" : "Veuillez saisir un slug de groupe valide!",
        "specialCharacterNotSupported" : "Les caractères spéciaux ne sont pas pris en charge",
        "descriptionRequired" : "La description du groupe est requise!",
        "emailRequired" : "Veuillez saisir une adresse courriel valide!",
        "fullNameRequired" : "Veuillez saisir un nom valide!"
      },
      "labels" : {
        "groupName" : "Nom du Groupe"
      }
    },
    "subscriptions" : {
      "manageSubscriptions" : "Gérer votre abonnement",
      "viewAndManageGroupSubscriptions" : "Voir et gérer l'abonnement du groupe",
      "paymentIntegrationMissingMessage" : "Veuillez intégrer les paiements in Emplacement pour le groupe Activer Payé",
      "price" : "Prix",
      "currency" : "Monnaie",
      "priceDisplay" : "{symbol}{price}{suffix}",
      "priceInterval" : "/{interval}",
      "oneTime" : " Une Date",
      "priceDeletedAlert" : "Paiement",
      "intervals" : {
        "month" : "Mois",
        "year" : "Année",
        "week" : "Semaine",
        "day" : "Jour"
      },
      "addNewPrice" : "Ajouter du nouveau prix",
      "editPrice" : "Modifier le Prix",
      "addPrice" : "Ajouter un Prix",
      "subscriptionType" : {
        "recurring" : "Récurrent",
        "oneTime" : "Une Date"
      },
      "billingPeriod" : {
        "monthly" : "Mensuel",
        "annually" : "Annuel",
        "weekly" : "Hebdomadaire",
        "daily" : "Quotidiennement"
      }
    },
    "menuOptions" : {
      "details" : "Détails",
      "subscriptions" : "Abandonner",
      "branding" : "Image de marque",
      "themes" : "Thème",
      "membershipQuestions" : "Question Adhésion",
      "gamificationAndRewards" : "Gamification et rétroaction",
      "links" : "Liens",
      "reportedContent" : "Contenu rapporté",
      "discovery" : "Découvrir",
      "import" : "Importer"
    },
    "groupSettings" : {
      "groupSettings" : "Réglages du Groupe",
      "changeGroupType" : "Changement du Type de Groupe",
      "changeGroupTypeDescriptionPrivateToPublic" : "dynamique pour un groupe Public signifie que tout en attente sera automatiquement accepté et le contenu sera visible publiquement. Poursuivre?",
      "changeGroupTypeDescriptionPublicToPrivate" : "Envoyez un message au groupe privé, ce qui signifie que les nouveaux membres doivent être approuvés et le contenu reste en l'attente jusqu'à ce qu'ils soient acceptés. Poursuivre?",
      "changeGroupTypeConfirmation" : "Êtes-vous sûr de vouloir changer le Type de groupe ?",
      "changeGroupTheme" : "Changement de Thème de Groupe",
      "changeGroupThemeDescription" : "Cela modifiera le changement pour tout le groupe. Êtes-vous sûr de vouloir changer de groupe?",
      "updatedGroupDetails" : "Détails du Groupe Mise à jour",
      "unableToSaveDetails" : "Oups! Impossible d'inclure des détails.",
      "groupNameIsRequired" : "Le Nom du groupe est obligatoire",
      "groupDescriptionIsRequired" : "Description du groupe est obligatoire",
      "groupSlugIsRequired" : "Le groupe Limace est obligatoire",
      "groupSlugMustContainOnly" : "Le groupe Limace doit contenir uniquement des lettres de minutes, de .",
      "groupSlugAlreadyExists" : "Le Limace du Groupe existe déjà. Veuillez utiliser un autre Limace car ce dernier est déjà pris",
      "pleaseTryAgainLater" : "Veuillez réessayer plus tard",
      "unsavedChangesMessage" : "Vous avez non enregistré Groupe Limace, êtes-vous sûr de vouloir les annuler?"
    },
    "import" : {
      "header" : "Importer les Membres du Groupe et leur Contenu",
      "credentialDescription" : "Entrez votre autorisation pour importer de votre groupe et de leur contenu",
      "csvUploadDescription" : "Sélectionner des .csv Envoyez un message au contact",
      "loginFailed" : "Vous avez saisi un mot de password non valide. Veuillez réessayer.",
      "proceedWithImport" : "Poursuivre avec Importer?",
      "iAgree" : "J'accepte",
      "importTerms" : "en cliquant sur « J'accepte », vous confirmez et reconnaissez que vous nous avez engagé en tant qu'accord indépendant pour fournir ServicesServices . Les Services comprennent le transfert de certaines données, des détails, du contenu, des Info Vous représentez et assurez-vous que (i) Vous êtes le propriétaire de l' Info in le compte de plateforme de diffusion, (secondaire) Vous avez les autorisations pour nous attribuer l'accès au compte de plateforme de diffusion pour l'intention de fournir des Services et (hui) la transfert de l' Info ne code pas les autorisations intellectuelles du tiers. Vous acceptez de nous indemniser, de nous défendre et de nous dégager de toute responsabilité pour toute réclamation de tiers découlant de votre violation des réponses et garanties ci-dessus.",
      "pleaseDownloadCSV" : "Veuillez télécharger le fichier .csv",
      "step01" : "Étape 01-",
      "step02" : "Étape 02-",
      "uploadCSV" : "Téléverser votre .csv",
      "step01Description" : "in ou mettre à jour toutes les informations manquantes pour les membres du groupe, telles que Gmail, Prénom, etc. Assurez-vous que le CSV est téléchargé in",
      "thisTemplate" : "ce modèle",
      "importCSV" : "Importer . CSV",
      "reSyncData" : "Resynchronisez vos données avant de télécharger.",
      "refreshUserList" : "Rafraîchir la liste de l'utilisateur",
      "reSyncDataDescription" : "Si de nouveaux utilisateurs sont ajoutés in le service, nous vous recommandons de rafraîchir votre liste et de télécharger le CSV.",
      "pleaseDontChangeProfileSlug" : "Veuillez ne pas modifier de profil d'instantané.",
      "selectFile" : "Sélectionner un Fichier",
      "changeFile" : "Changement de Fichier",
      "importMembersFailedText" : "Cela peut être dû au fait qu'ils sont manquants. Veuillez vérifier votre importation et réessayer avec des adresses courriel valides pour ces membres.",
      "upload" : "Téléverser",
      "tryAgain" : "Réessayer",
      "syncAllPosts" : "Synchronisation de votre partage et de votre commentaire",
      "membersCouldNotBeAdded" : "Les membres n'ont pas pu être ajoutés au groupe.",
      "importMembersSuccess" : "Nous avons envoyé un courriel pour présenter des membres du groupe, confirmant leur adhésion in groupe et leur offrant des détails. Cela aide à s' assurer que tous les membres sont mis à jour et peuvent accéder au groupe efficacement.",
      "importMembersAdded" : "Les membres ont été ajoutés avec succès au groupe",
      "postsNotSynced" : "Les messages restants n'ont pas pu être synchronisés avec le groupe. Cela peut être dû au fait que les utilisateurs de Partager n'ont pas été importé avec succès.",
      "migrationFailed" : "Échec de la transition. Veuillez réessayer.",
      "migrationCompleted" : "Terme de flux de travail!",
      "migrationInProgress" : "Suppression in cours!",
      "uploadingInProgress" : "Téléverser in cours!",
      "listMembers" : "La liste des membres est en cours",
      "downloaded" : "Télécharger",
      "uploaded" : "téléchargé",
      "listPostsDownloaded" : "La liste des publications est Télécharger.",
      "listPostsDownloading" : "La liste des publications est en cours de téléchargement.",
      "posts" : "poste",
      "members" : "Membres",
      "imported" : "importé",
      "step1" : "Étape 1",
      "step2" : "Étape 2",
      "step1Description" : "Créer un profil de membre in le groupe .",
      "step1Description2" : "(y compris le Nom, l'Id de Courriel et le mot de passe)",
      "step2Description" : "Saisir l'Certificat de la session",
      "emailPlaceholder" : "Entrez l'Id de Courriel de votre Id de l'équipe",
      "emailTooltip" : "Saisissez les membres du courriel avec votre compte de textos",
      "passwordPlaceholder" : "Entrez le mot de passe de votre équipe",
      "confirm" : "Confirme",
      "validation" : {
        "skoolUrl" : "Veuillez saisir une URL de l'équipe valide",
        "email" : "Le courriel est obligatoire",
        "password" : "Le mot de passe est obligatoire"
      }
    }
  },
  "invitations" : {
    "intent" : "Aidez cette communauté à grandir!",
    "cancelInvitation" : "Annuler l'invitation",
    "inviteMembers" : "Invitez les membres à collaborer sur cette communauté.",
    "inviteLink" : "Lien d'invitation",
    "buildYourCommunity" : "Bâtissez votre communauté!",
    "inviteMembersToCollaborate" : "Vous avez créé une nouvelle communauté! Invitez les membres à collaborer sur cette communauté.",
    "invite" : "Inviter"
  },
  "createPost" : {
    "title" : "Créer un nouvel article de blogue",
    "placeholder" : "Qu’est-ce que vous avez en tête",
    "slug" : "Lien URL de l'article de blogue",
    "titleHelp" : "La légende, la description et l'image seront utilisés pour la balise méta SEO",
    "nameLabel" : "Légende de l'article de blogue",
    "nameValidation" : "Une légende est requise",
    "descriptionLabel" : "Description de la publication",
    "descriptionHelp" : "Donnez une brève description pour que les spectateurs puissent avoir un aperçu de la publication. Fonctionne mieux entre 100 et 250 caractères",
    "descriptionValidation" : "Une description est requise",
    "createLabel" : "Créer une publication",
    "image" : "Photo de l'article de blogue",
    "imageDescription" : "La taille recommandée est de 600 px * 400 px",
    "notificationTitle" : "Article de blogue créé",
    "notificationErrorTitle" : "Impossible de générer un article de blogue",
    "postingIn" : "in",
    "editingIn" : "in"
  },
  "post" : {
    "deletePost" : "Supprimer le message",
    "reportPost" : "Signaler un message",
    "editPost" : "Modifier le message",
    "createPost" : "Créer une publication",
    "publish" : "Poste",
    "publishPost" : "Publier un message",
    "addChannel" : "Ajouter une chaîne",
    "selectChannel" : "Veuillez sélectionner la chaîne",
    "addLink" : "Ajouter un lien",
    "removeLink" : "Extraire le Lien",
    "update" : "Mise à jour",
    "unsavedChanges" : "Vous avez des modifications non enregistrées",
    "unsavedChangesMessage" : "Vos modifications non enregistrées seront perdues. Voulez-vous quand même continuer?",
    "unpinFromChannel" : "Unpin",
    "unpinFromHome" : "Unpin",
    "deletePostConfirmation" : "Êtes-vous sûr de vouloir supprimer ce billet?",
    "reportPostConfirmation" : "Voulez-vous vraiment signaler cette publication?",
    "postNotFound" : "Poste introuvable",
    "postNotFoundMessage" : "Le Partager que vous essayez de voir est soit Supprimé, soit n'existe pas.",
    "loadMoreComments" : "Charger plus de commentaires",
    "channelNotFound" : "Chaîne non trouvée",
    "isCurrentlyLive" : "est maintenant en direct",
    "isStartingNow" : "commence maintenant",
    "isHappeningInMinutes" : "se passe dans {minutes} minutes",
    "isHappeningInHours" : "se produit in {hours} l'heure | se produit in {hours} l’heure",
    "publicChannel" : "Chaîne publique",
    "privateChannel" : "Canal privé",
    "featured" : "En vedette",
    "featuredAbout" : "À propos de Vedette",
    "noPostsFound" : "Aucun publication trouvée",
    "pinInfo" : "Vous pouvez épingler des éléments à afficher en haut de la Collection, y compris des publications, des règles et des hashtags.",
    "pinInfoEveryone" : "Tout le monde dans le groupe verra ces éléments.",
    "pinInfoRemainVisible" : "Les objets épinglés restent visibles jusqu'à ce que vous les déépinglez.",
    "pinInfoNewestItem" : "Au fur et à mesure que vous épinglez des articles, l'élément le plus récent apparaît en haut de la liste.",
    "onlyVisibleToAdmins" : "Visible uniquement par les administrateurs",
    "featuredAboutDescription" : "Vos administrateurs ont épinglé ces éléments pour que la Collection puisse les voir.",
    "channelNotFoundMessage" : "Vous n'êtes plus membre de la chaîne à laquelle vous essayez d'accéder ou la chaîne a été supprimée.",
    "notifications" : {
      "unpinned" : "Non épinglé!",
      "pinned" : "Gagné!",
      "reported" : "Le message a été signalé!",
      "error" : "Une erreur s'est produite!"
    },
    "movePostToChannel" : "Déplacer vers le Canal",
    "pin" : "NIP",
    "pinToHome" : "NIP à la Accueil",
    "pinToChannel" : "NIP au Canal",
    "whatIsYourTitle" : "Quel est votre titre?",
    "postMovedToChannel" : "Partager déplacé dans {channelName} canal",
    "onlyAdminsCanPost" : "Only community admins can post in this channel."
  },
  "reaction" : {
    "noLikes" : "Pas de mentions « j'aime »",
    "andOthers" : "et {count} autres"
  },
  "UIConfirmation" : {
    "privateGroup" : "Cette Collection est privée",
    "privateGroupMessage" : "Vous devez être membre de cette Collection pour accéder à l'information spécifique au groupe. Veuillez demander l'accès en cliquant sur le bouton Rejoindre la Collection."
  },
  "notifications" : {
    "noNotificationsYet" : "Aucune notification pour le moment",
    "whenYouGetNotifications" : "Quand vous recevez des notifications, elles s'afficheront ici",
    "markAllAsRead" : "Marquer tout comme lu",
    "notifications" : "Notifications",
    "all" : "Tous",
    "unread" : "Non lu",
    "checkNotifications" : "Ouvrir une session pour vérifier les notifications",
    "noNotifications" : "Aucune notification!",
    "redirectedFromOldSlug" : {
      "title" : "Vous avez été redirigé vers le lien mis à jour de la communauté",
      "content" : "Cela a été fait pour optimiser la performance SEO de cette communauté. Veuillez mettre à jour vos signets avec cette nouvelle URL."
    }
  },
  "joinGroupModal" : {
    "wahoo" : "Wahoo! 🎉, demande envoyée avec succès",
    "reviewRequestSoon" : "Nos administrateurs de groupe examineront bientôt votre demande. Soyez patient et nous vous informerons une fois votre adhésion approuvée.",
    "nonMemberMessage" : "Vous devez faire partie de cette Collection pour aimer et commenter les publications",
    "subscribeFor" : "Abonnez-vous pour",
    "joinGroup" : "REJOINDRE LE GROUPE",
    "membershipPending" : "Adhésion en attente",
    "viewMembershipAnswers" : "Voir les réponses des Adhésion",
    "requested" : "Demandé",
    "dayFreeTrial" : "Jour d'essai gratuit",
    "notPartOfGroup" : "Vous ne faites pas encore partie de ce groupe, vos demandes d'adhésion sont in avis. Une fois qu'un administrateur accepte vos demandes, nous vous enverrons une notification",
    "pleaseAnswerMembershipQuestions" : "Veuillez répondre aux questions d'adhésion pour associer ce groupe",
    "answerQuestions" : "Répondre aux questions d’adhésion"
  },
  "userProfilePopover" : {
    "active" : "Actif",
    "longAgo" : "il y a longtemps",
    "chatDisabled" : "Cet utilisateur a désactivé son chat",
    "pointsToLevelUp" : "Points pour monter de niveau",
    "profile" : "Profil",
    "deletedUser" : "Utilisateur supprimé",
    "joined" : "Rejoint",
    "contributions" : "Contributions"
  },
  "courses" : {
    "addCourse" : "Ajouter un cours",
    "updateCourse" : "Mettre à jour le cours",
    "access" : "Tous les membres ont accès",
    "unableToAddCourse" : "Oups! Impossible d'ajouter le cours.",
    "pleaseTryAgainLater" : "Veuillez réessayer plus tard",
    "paymentIntegrationMissing" : "Oups! L'intégration du paiement est manquante",
    "paymentIntegrationMissingMessage" : "Veuillez intégrer les paiements dans l'emplacement pour activer les cours payants",
    "course" : "Cours",
    "courseInThisGroup" : "un cours dans cette Collection",
    "courseLinkCopied" : "Lien du cours copié!",
    "buyNow" : "ACHETEZ MAINTENANT",
    "locked" : "UTILISATEUR",
    "buyCourse" : "ACHETER UN COURS",
    "open" : "OUVERT",
    "moveCard" : "Déplacer la carte",
    "courseViewMessage" : "Vous devez faire partie de cette Collection pour voir les Cours.",
    "deleteCourse" : "Supprimer le cours",
    "deleteCourseConfirmation" : "Êtes-vous sûr de vouloir supprimer ce cours?",
    "courseAccessNotGranted" : "Accès aux cours non accordé",
    "courseAccessNotGrantedMessage" : "Nous travaillons actuellement à vous accorder l'accès au cours. Veuillez actualiser la page et réessayer dans une minute.",
    "autoRenewsAfter" : "Se renouvelle automatiquement après",
    "oneTimePayment" : "Paiement unique",
    "emptyCoursesMessage" : "Apparence d'une ville fantôme. Rien à voir ici!",
    "updatedSuccessfully" : "Mise à jour avec succès",
    "addedSuccessfully" : "Cours ajouté avec succès",
    "labels" : {
      "selectCourse" : "Sélectionner un cours",
      "courseVisibility" : "Visibilité pour le cours",
      "courseAccess" : "Accès aux cours",
      "coursePrice" : "Prix du cours",
      "subscriptionType" : "Type d'abonnement",
      "billingPeriod" : "Période de facturation",
      "testMode" : "Mode essai",
      "turnOnTestPayments" : "Activer les paiements de test à l'aide d'une carte de test",
      "currency" : "Monnaie",
      "trialDays" : "Jours d'essai",
      "recurring" : "Récurrent",
      "free" : "Gratuit",
      "oneTime" : "Une Date",
      "refresh" : "Rafraîchir",
      "accessStartsAtDay" : "Accès commence le Jour",
      "maximumYouCanEnterIs365" : "Le Max de votre saisie est de 365",
      "allMembers" : "Tous les membres",
      "levelUnlock" : "Dépannage",
      "buyNow" : "Acheter maintenant",
      "timeUnlock" : "Date non verrouillé",
      "gamificationLevel" : "Gamification",
      "privateChannel" : "Canal Privé",
      "marketingChannel" : "Marketing des Canal"
    },
    "placeholders" : {
      "enterPrice" : "Entrez le prix",
      "enterTrialDays" : "Entrez les jours d'essai",
      "selectCurrency" : "Sélectionnez une option",
      "selectBillingPeriod" : "Sélectionnez une option"
    },
    "validations" : {
      "validPrice" : "Veuillez saisir un prix valide",
      "required" : "Veuillez sélectionner un cours",
      "validMembershipPrice" : "Veuillez saisir un prix d'adhésion valide",
      "validTrialDays" : "Veuillez saisir des jours d'essai valides",
      "requiredSubscriptionType" : "Veuillez sélectionner le type d'abonnement",
      "courseVisibility" : "Veuillez sélectionner la visite de cours",
      "requiredGamificationLevel" : "Veuillez sélectionner le Gamification",
      "requiredPrivateChannel" : "Veuillez sélectionner le canal privé",
      "validAccessStartDay" : "Veuillez saisir un jour de début de l'accès valide"
    },
    "descriptions" : {
      "buyNowDescription" : "Ce cours est Public lors de l'achat",
      "timeUnlockDescription" : "Membres",
      "levelUnlockDescription" : "Les membres uniquement à un certain Plat pourront déconnecter",
      "allMembersDescription" : "Tous les membres ont accès à ce cours",
      "privateChannelDescription" : "Membres d'un canal privé"
    },
    "helperText" : {
      "levelBased" : "En fonction du niveau",
      "timeLimited" : "Limite de l'heure",
      "free" : "Gratuit",
      "levelAvailableAt" : "disponible à Plat{value}",
      "timeLimitedAfterJoining" : "Envoyez {value} Public au {day}",
      "day" : "Jour",
      "days" : "jours",
      "purchaseToUnlockAccess" : "Acheter ce cours pour déconnecter l'accès",
      "locked" : "Ce cours est verrouillé",
      "unlockAtLevel" : "Ce cours se déconnectera à {level}",
      "unlockAfterDays" : "Ce cours se déconnectera après {days} {dayText}",
      "privateChannelBased" : "Base de canaux Privé"
    }
  },
  "leaderboard" : {
    "level" : "Niveau",
    "lastUpdated" : "Dernière mise à jour",
    "members" : "Membres",
    "percentOfMembers" : "{percentage} % des membres",
    "rewards" : "Récompenses",
    "allTime" : "Tout le temps",
    "pointsToLevelUp" : "Points pour monter de niveau",
    "points" : "Points",
    "leaderboard7d" : "Classement (7 jours)",
    "leaderboard30d" : "Leaderboard (30 jours)",
    "leaderboardAlltime" : "Leaderboard (Tout le temps)",
    "yourRank" : "Votre rang",
    "noActivityToShow" : "Aucune activité à afficher",
    "rewardsWillBeDisplayedHere" : "Les récompenses seront affichées ici",
    "seeAllLeaderboards" : "Voir tous les classements",
    "addRewards" : "Ajouter des récompenses",
    "howPointsWork" : "Vous gagnez des Points quand d'autres Membres aiment vos publications ou votre rétroaction. 1 j'aime = 1 point. Cela encourage les Utilisateurs à Générer du contenu de qualité et à interagir avec les autres Membres de leur communauté.",
    "levels" : "Niveaux",
    "levelsDescription" : "Au fur et à mesure que vous gagnez des Points, vous montez de niveau. Votre niveau est affiché en bas à droite de votre avatar. Le nombre de points requis pour passer au niveau suivant est montré via la barre de progression sur la page du classement.",
    "pointsAndLevels" : "Points et coupons"
  },
  "events" : {
    "createEvent" : "Créer un événement",
    "dragAndDrop" : "Faites glisser et déposer un fichier SVG, PNG ou JPG (Max 800 x 400 px)",
    "editEvent" : "Modifier l'événement",
    "addEvent" : "Ajouter un événement",
    "paymentDetails" : "Détails du paiement",
    "event" : "Événement",
    "goBack" : "Retour",
    "cancelEdit" : "Annuler l’édition",
    "cancelEvent" : "Annuler l'événement",
    "next" : "Suivant",
    "saveEvent" : "Sauvegarder l'événement",
    "editRecurringEvent" : "Modifier l'événement récurrent",
    "thisEvent" : "Cet événement",
    "thisAndFollowingEvents" : "Cet événement et les suivants",
    "ok" : "OK",
    "deleteRecurringEvent" : "Supprimer l’événement récurrent",
    "allEvents" : "Tous les événements",
    "adminsFreeForPaidEvents" : " * Les administrateurs peuvent S'inscrire pour des événements payants pour des gratuits",
    "deleteEvent" : "Supprimer l’événement",
    "onceEventDeleted" : "Une fois l'événement supprimé, il ne s'affichera pas dans votre calendrier.",
    "toRegister" : "pour s'inscrire",
    "calendar" : "Calendrier",
    "addToCalendar" : "Ajouter au calendrier",
    "declineRegistration" : "Refuser",
    "paymentFailedMessage" : "Votre paiement a échoué en raison de circonstances imprévues! Veuillez réessayer plus tard",
    "upcoming" : "À venir",
    "noMoreEvents" : "Il n'y a plus d'occurrences à montrer",
    "joinGroupToRegister" : "Vous devez faire partie de cette Collection pour vous inscrire à cet Événement",
    "past" : "Passé",
    "youHaveRegisteredForOneEvent" : "Vous vous êtes inscrit à 1 événement. Nous vous enverrons un rappel un jour avant chaque événement.",
    "upcomingEvents" : "Événements à venir",
    "noUpcomingEvents" : "Aucun événement à venir",
    "pastEvents" : "Événements passés",
    "noPastEvents" : "Pas d'événements passés",
    "noMatchingEventFound" : "Aucun événement correspondant n'a été trouvé",
    "week" : "Semaine",
    "month" : "Mois",
    "today" : "Aujourd'hui",
    "registrationConfirmed" : "Confirmation d'inscription pour {event}.",
    "validations" : {
      "titleValidation" : "Une légende est requise",
      "colorValidation" : "La couleur est obligatoire",
      "startTimeValidation" : "L'heure de début est obligatoire",
      "endTimeValidation" : "L'heure de fin est obligatoire",
      "endTimeAfterStartTime" : "L'heure de fin doit être postérieure à l'heure de début!",
      "startTimeMustBeInFuture" : "L'heure de début doit être dans le futur",
      "locationValidation" : "L'emplacement est requis",
      "locationValidationMobile" : "L'emplacement est req",
      "locationUrlValidation" : "Une URL d'emplacement valide est nécessaire",
      "descriptionValidation" : "Une description est requise",
      "descriptionValidationMaxLength" : "La description ne doit pas dépasser 300 caractères",
      "recaptchaError" : "La vérification a échoué! Veuillez réessayer",
      "repeatIntervalValidation" : "L'occurrence est requise",
      "repeatIntervalValidator" : "L’intervalle de répétition doit être un jour, une semaine, un mois ou une année.",
      "repeatIntervalRequired" : "L'intervalle de répétition est obligatoire.",
      "repeatOccurrenceValidator" : "La fréquence de répétition doit être supérieure à 0.",
      "repeatOccurrenceRequired" : "La fréquence de répétition est obligatoire.",
      "invalidDateFormat" : "Format de date non valide",
      "endDateMustBeAfterStartDate" : "La Date de fin doit être après la Date de début de l'événement",
      "recurringEndDateValidation" : "La Date de fin récurrente est obligatoire",
      "repeatsOnValidation" : "Veuillez sélectionner au moins un jour",
      "invalidDaySelection" : "Sélection de jour non valide",
      "endOptionRequired" : "L'option de fin est obligatoire",
      "levelValidation" : "Veuillez sélectionner un niveau",
      "courseValidation" : "Veuillez sélectionner un cours",
      "channelValidation" : "Veuillez sélectionner une chaîne",
      "eventPriceValidation" : "Le prix est obligatoire et doit être supérieur à {min}"
    },
    "placeholders" : {
      "selectStartTime" : "Sélectionner l'heure de début",
      "selectEndTime" : "Sélectionnez l’heure de fin",
      "selectLocation" : "Sélectionner l'emplacement",
      "locationUrl" : "Lien/Adresse",
      "description" : "Description",
      "selectRecurringEndDate" : "Sélectionnez Date de fin récurrente",
      "selectDate" : "Sélectionner la date",
      "event" : "Événement",
      "selectColor" : "Sélectionnez une couleur",
      "selectAttendees" : "Sélectionner les participants",
      "selectPrivateChannel" : "Sélectionnez le canal privé",
      "selectCourse" : "Sélectionner un cours",
      "selectLevels" : "Sélectionner les Couches",
      "selectCalendar" : "Sélectionne le calendrier"
    },
    "labels" : {
      "startTime" : "Heure de début",
      "endTime" : "Heure de fin",
      "others" : "Autres",
      "oneTimePriceForEventRegistration" : "prix unique pour l'inscription à l'événement.",
      "totalAmount" : "Montant total",
      "cardAuthorizationText" : "En fournissant les détails de votre carte, vous autorisez {locationName} à débiter votre carte pour des paiements futurs conformément à leurs conditions.",
      "secureAndSafePayments" : "Paiements 100 % sécurisés et sûrs",
      "day" : "Jour",
      "week" : "Semaine",
      "month" : "Mois",
      "year" : "Année",
      "recurringEvent" : "L'événement sera-t-il un événement récurrent?",
      "repeatsEvery" : "Répéter tout",
      "repeatsOn" : "Répète le",
      "end" : "Fin",
      "ends" : "Fin",
      "neverEnds" : "Ne finit jamais",
      "orange" : "Orange",
      "red" : "Rouge",
      "blue" : "Bleu",
      "green" : "Vert",
      "violet" : "Violet",
      "purple" : "Pourpre",
      "yellow" : "Jaune",
      "title" : "Titre",
      "color" : "Couleur",
      "allMembers" : "Tous les membres",
      "membersAtALevel" : "Membres au niveau Plat",
      "membersOfACourse" : "Membres d'un cours",
      "membersOfAPrivateChannel" : "Membres d'une chaîne privée",
      "whoCanAttendTheEvent" : "Qui peut participer à l'événement?",
      "channel" : "Canal",
      "course" : "Cours",
      "level" : "Niveau",
      "remindAttendeesByEmail" : "Rappeler aux participants via Courriel 1 Jour Avant",
      "hideLocationFromNonAttendees" : "Cacher l’emplacement aux non-participants.",
      "addChargesToTheEvent" : "Ajouter une facture à l'événement",
      "noPaymentRequired" : "Aucun paiement obligatoire",
      "location" : "Emplacement",
      "link" : "Lien",
      "description" : "Description",
      "timezone" : "Fuseau horaire",
      "eventType" : "Type d’événement",
      "eventTypeChangeWarning" : "Des prix dynamiques pour le Type d'événement s'appliqueront à toutes les occurrences in la ligne.",
      "never" : "Jamais",
      "on" : "Allumé",
      "after" : "Après",
      "occurrences" : "occurrences",
      "selectEventEnd" : "OK",
      "turnOnTestPayments" : "Paiements d'essais au moyen d'une carte d'essai",
      "pay" : "Rémunérer",
      "hideAttendees" : "Cacher les participants de groupe",
      "guests" : "ID {count} l'invité",
      "guestList" : "Liste des Invité",
      "noAttendees" : "Aucun participant pour le moment",
      "viewAttendees" : "Voir les participants",
      "exportAttendees" : "Exporter les participants"
    },
    "notifications" : {
      "eventCreated" : "Présentez des événements avec succès!",
      "eventUpdated" : "Mise à jour avec succès!",
      "eventCreationFailed" : "La création Événement a échoué!",
      "eventUpdateFailed" : "Mise à jour de Événement",
      "eventDeleted" : "Événement supprimé avec succès!",
      "eventDeletionFailed" : "La suppression de l'événement a échoué!",
      "paymentFailed" : "Le paiement a échoué!",
      "registrationSuccessful" : "Inscription réussie!",
      "registrationFailed" : "Inscription échouée!",
      "addToCalendarFailed" : "Impossible d'inclure l'événement au calendrier!",
      "locationDetailsCopied" : "Détails de l'emplacement copiés dans le presse-papiers!",
      "registrationDeclined" : "Inscription refusée avec succès!",
      "registrationDeclinedFailed" : "Le rejet des inscriptions a échoué!",
      "fetchAttendeesFailed" : "Échec de charger les participants",
      "emailCopied" : "Copier le courriel dans le presse-papiers"
    }
  },
  "login" : {
    "invite" : "vous a invité à rejoindre"
  },
  "contentReports" : {
    "contentDeleted" : "Le contenu a été supprimé !",
    "noActionTaken" : "Aucune action prise concernant le contenu signalé!",
    "reportedContentNotFound" : "Contenu signalé non trouvé, peut-être déjà traité.",
    "reported" : "Rapporté",
    "viewAllReportedContentHere" : "Vous pouvez voir tout le contenu signalé ici",
    "takeActionOnReportedContent" : "Prendre des mesures concernant le contenu signalé",
    "andOthers" : "et {count} autres",
    "reportedThisPost" : "a rapporté ce post",
    "keep" : "GARDER",
    "remove" : "SUPPRIMER",
    "deleteContent" : "Supprimer le contenu",
    "deleteConfirmation" : "Voulez-vous vraiment supprimer ce contenu ?",
    "noMemberReportedContent" : "Pas de contenu rapporté par les membres",
    "whenMembersReportPostsOrComments" : "Quand les membres signalent des messages ou des commentaires, ils apparaissent ici pour que vous puissiez les examiner. Vous pouvez les garder ou les supprimer, ainsi que suspendre, supprimer ou bloquer les membres qui les ont publiées."
  },
  "contentUnavailable" : {
    "thisContentIsntAvailable" : "Ce contenu n'est pas disponible pour le moment",
    "whenThisHappens" : "Lorsque cela arrive, c'est généralement parce que le propriétaire ne l'a partagé qu'avec un petit groupe de personnes ou a changé qui peut le voir ou il a été supprimé"
  },
  "noCommunities" : {
    "noCommunitiesFound" : "Aucune communauté trouvée",
    "startCreatingYourOwnCommunities" : "Commencez à créer vos propres communautés et interagissez avec votre public!",
    "noCommunitiesFoundGokollab" : {
      "notJoinedA" : "Not Joined a",
      "communities" : "Communities",
      "yet" : "Yet"
    },
    "noCommunitiesFoundGokollabDescription" : "Discover spaces where people share ideas, support each other, and grow together."
  },
  "noCourses" : {
    "noCoursesFoundGokollab" : {
      "notEnrolledInA" : "Not Enrolled in a",
      "course" : "Course",
      "yet" : "Yet"
    },
    "noCoursesFoundGokollabDescription" : "Explore high-impact courses designed to help you learn, improve, and succeed."
  },
  "notFound" : {
    "ohNo" : "oh non...",
    "weHaveHadAnError" : "Nous avons eu une erreur",
    "error404" : "Erreur 404",
    "sorryPleaseCheckBack" : "Désolé... veuillez revenir dans un instant."
  },
  "time" : {
    "justNow" : "Tout maintenant",
    "timeAgo" : "Il y a {value}{unit}",
    "timeAgoFull" : "Il y a  {value} {unit}",
    "units" : {
      "year" : "y",
      "years" : "années",
      "month" : "Mo",
      "months" : "mois",
      "week" : "w",
      "weeks" : "semaines",
      "day" : "d",
      "days" : "jours",
      "hour" : "H",
      "hours" : "heures",
      "minute" : "M",
      "minutes" : "minutes",
      "second" : "s",
      "seconds" : "Secondes",
      "monthly" : "Mensuel",
      "weekly" : "Hebdomadaire",
      "annually" : "Annuel"
    }
  },
  "emojiPicker" : {
    "notfound" : "Aucun courriel trouvé",
    "recent" : "Fréquence utilisée",
    "smileys" : "SMS",
    "people" : "Personnel et Corps",
    "nature" : "Entreprises et nature",
    "foods" : "Restaurer",
    "activity" : "Activité",
    "places" : "Déplacement et sièges",
    "objects" : "Objets",
    "symbols" : "Symboles",
    "flags" : "Drapeaux",
    "custom" : "Personnalisé"
  },
  "topNavBarHeaderText" : {
    "discussion" : "Clavardage",
    "learning" : "éducation",
    "people" : "Personnel"
  }
}
